import fetch from '@adc/fetch'
import { gql } from '@adc/sdk'
import { IngestResult } from '@adc/sdk/types'

/**
 * Encrypt a loan number via the `ingest` GraphQL mutation.
 *
 * Sends a typed `metadata.batch_loan_encryption` member. The graph validates
 * the input natively and routes it to the ingest service.
 *
 * @param orgId - Servicer's organization ID (from SF account)
 * @param loanNumber - Clear-text loan number to encrypt
 */
export const encryptLoanNumber = (
  orgId: number,
  loanNumber: string
): Promise<IngestResult> => {
  return fetch
    .forAuctionGraph<'ingest', IngestResult>({
      variables: {
        input: {
          metadata: {
            batch_loan_encryption: {
              org_id: orgId,
              loan_numbers: [loanNumber],
            },
          },
        },
      },
      query: gql`
        mutation morpheus_ingest($input: IngestInput!) {
          ingest(input: $input) {
            uuid
          }
        }
      `,
    })
    .then(response => {
      if (response.body.errors && response.body.errors[0]) {
        throw response.body.errors[0]
      }

      const result = response.body.data.ingest

      if (!result?.uuid) {
        throw new Error('Encryption succeeded but no UUID was returned.')
      }

      return result
    })
}
